import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import app from './app';
import debug from './debug';
import user from './user';
import area from './area';
import listing from './listing';
import ratingAndReview from './ratingAndReview';
import moveInFeedback from './moveInFeedback';
import autocompleteAddress from './autocompleteAddress';

const rootReducer = (history) => {
    return combineReducers({
        router: connectRouter(history),
        app,
        debug,
        user,
        area,
        ratingAndReview,
        listing,
        moveInFeedback,
        autocompleteAddress,
    });
};

export default rootReducer;
